import { Link } from 'react-router-dom';
import useUISettings from '../../hooks/useUISettings';

function Footer() {
  const { siteName, logoUrl } = useUISettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Logo and copyright */}
          <div className="flex items-center space-x-2 mb-4 md:mb-0">
            <div className="w-8 h-8 rounded-lg gradient-bg flex items-center justify-center">
              {logoUrl ? (
                <img src={logoUrl} alt={siteName} className="w-8 h-8 rounded-lg object-cover" />
              ) : (
                <span className="text-white font-bold">{siteName?.[0] || 'V'}</span>
              )}
            </div>
            <span className="text-gray-400 text-sm">
              © {currentYear} {siteName}. All rights reserved.
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center space-x-6">
            <Link
              to="/privacy"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Terms of Service
            </Link>
            <a
              href="mailto:support@voxifyai.com"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
